/* ═══════════════════════════════════════════════════════════════
   Tasks Kit — shared types + constants used across TasksKit,
   TasksToolbar, TasksTable, TasksBoard and TaskSheet. Moved out of
   the former Tasks page as-is (STATUS_COLS / PRIORITY_COLORS / PRIORITY_LABELS
   were module-level constants there too).
   ═══════════════════════════════════════════════════════════════ */
import type { TaskPriority, TaskStatus } from '../../../shared/types';

export type ViewMode = 'board' | 'list';

/** Replaces the old Tasks page `projectId`/`embedded` props — embedded
 *  behavior (Project Canvas host) is simply `scope.projectId` being set. */
export interface TasksScope {
  projectId?: string;
}

export const STATUS_COLS: { id: TaskStatus; label: string; color: string }[] = [
  { id: 'todo', label: 'To Do', color: 'var(--tm)' },
  { id: 'in_progress', label: 'In Progress', color: 'var(--ac)' },
  { id: 'review', label: 'Review', color: 'var(--color-warning)' },
  { id: 'done', label: 'Done', color: 'var(--ok)' },
];

export const PRIORITY_COLORS: Record<TaskPriority, string> = {
  low: 'var(--tm)',
  medium: 'var(--ac)',
  high: 'var(--color-warning)',
  urgent: 'var(--dg)',
};

export const PRIORITY_LABELS: Record<TaskPriority, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  urgent: 'Urgent',
};
